module.exports = __webpack_public_path__ + "static/media/glanum_brunnen.cb7c716b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_brunnen.png
// module id = 713
// module chunks = 0